import React from 'react'

import ChartWrapper from '../ChartWrapper'
import Chart from './FocusChart.d3'

const FocusChart = ({
  data,
  events,
  toggleProps,
  transform,
  setTransform,
  selection,
  registerFocusChartTimeChange,
  currency,
}) => {
  const triggerZoom = event => {
    setTransform(event)
  }

  const updateProps = React.useMemo(() => ({ data, events }), [data, events])

  return (
    <ChartWrapper
      Chart={Chart}
      initProps={{ data, events, triggerZoom, registerFocusChartTimeChange, currency }}
      updateProps={updateProps}
      toggleProps={toggleProps}
      margin={{ BOTTOM: 20, LEFT: 0 }}
      useBrush
      brushProps={selection}
      useZoom
      useToggle
      zoomProps={transform}
    />
  )
}

export default FocusChart
